import cloneDeep from 'clone-deep'
import { LayoutLoading } from 'components/LayoutLoading'
import { LoanPipelineHeaderConfigs } from 'components/LoanPipelineHeaderConfigs'
import type { HeaderRow } from 'components/LoanPipelineHeaderConfigs/HeaderSelectionModal'
import { useEffect, useRef, useState } from 'react'
import { getAdminConfig, setAdminConfig } from 'services'

export const PipelineServicingEmailHeadersConfig = () => {
  const [isLoading, setLoading] = useState(false)
  const [headers, setHeaders] = useState<HeaderRow[]>([])
  const dataRef = useRef<Record<string, any>>({})

  useEffect(() => {
    setLoading(true)
    getAdminConfig('emailParties')
      .then((res) => {
        dataRef.current = res
        setHeaders(res.pipelineServicingEmailHeaders || [])
      })
      .finally(() => setLoading(false))
  }, [])

  const onSave = async (values: HeaderRow[]) => {
    const temp = cloneDeep(dataRef.current)
    temp.pipelineServicingEmailHeaders = values
    dataRef.current = temp
    setHeaders(values)

    setLoading(true)
    await setAdminConfig('emailParties', temp)
    setLoading(false)
  }

  return (
    <div className="relative">
      <LayoutLoading show={isLoading} />
      <LoanPipelineHeaderConfigs
        autoSave
        maxRows={1}
        values={headers}
        setLoading={setLoading}
        onSave={onSave}
      />
    </div>
  )
}
